window.addEventListener('DOMContentLoaded', (event) => {

    var processSwiper = new Swiper(".process-swiper", {
        direction: "vertical",
        autoplay: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        allowTouchMove: false,
        slidesPerView: 1,
        centeredSlides: true,
        // slidesPerView: 3,
        // slidesPerGroup: 1,
        loop: true,
        breakpoints: {
          // when window width is >= 320px
          768: {
            slidesPerView: 2,
          }
        }
    });

    const appDiv = document.getElementById('pillar-anim-app');

    const pillarColors = [
        {
            color: 'yellow',
            hex: '#FFB600',
        },
        {
            color: 'green',
            hex: '#70C500',
        },
        {
            color: 'navy',
            hex: '#004F71',
        },
        {
            color: 'teal',
            hex: '#15B6BE',
        },
        {
            color: 'blue',
            hex: '#009CDE',
        },
        {
            color: 'orange',
            hex: '#F98B30',
        },
        {
            color: 'white',
            hex: '#FFFFFF',
        },
    ];

    const miscColors = [
        {
            color: 'pink',
            hex: '#EF4B81',
        },
        {
            color: 'grey',
            hex: '#D6D6D6',
        },
        {
            color: 'white',
            hex: '#FFFFFF',
        },
        {
            color: 'background',
            hex: '#F2F2F2',
        },
    ];

    const resourceTypes = [
        {
            type: 'checklist',
            icon: '<svg version="1.1" class="resource-icon" id="resourceType_checklist" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve"> <path id="resourceBackground" d="M146,52.3c-0.2-1.7-1-3.3-2.2-4.5l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2l0,0H47.8 c-4.5,0-8.2,3.7-8.2,8.2v124.6c0,4.5,3.7,8.2,8.2,8.2h90.1c4.5,0,8.2-3.7,8.2-8.2V53.2l0,0L146,52.3L146,52.3L146,52.3z"/> <g style="opacity:0.1;"> <path d="M146.1,53.2L146.1,53.2c0-2-0.8-4-2.2-5.4l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2v24.1c0,3.6,2.9,6.5,6.5,6.5 L146.1,53.2L146.1,53.2z"/> </g> <g id="resourceObject"> <path d="M117.9,85.4h-33c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h33c1.2,0,2.2,1,2.2,2.2 S119.2,85.4,117.9,85.4z"/> <path d="M74.9,89.1h-8.8c-1,0-1.8-0.8-1.8-1.8v-8.4c0-1,0.8-1.8,1.8-1.8h8.8c1,0,1.8,0.8,1.8,1.8v8.4 C76.7,88.3,75.9,89.1,74.9,89.1z M67.8,85.6h5.3v-4.9h-5.3V85.6z"/> <path d="M117.9,102.2h-33c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h33c1.2,0,2.2,1,2.2,2.2 S119.2,102.2,117.9,102.2z"/> <path d="M74.9,105.9h-8.8c-1,0-1.8-0.8-1.8-1.8v-8.4c0-1,0.8-1.8,1.8-1.8h8.8c1,0,1.8,0.8,1.8,1.8v8.4 C76.7,105.2,75.9,105.9,74.9,105.9z M67.8,102.4h5.3v-4.9h-5.3V102.4z"/> <path d="M117.9,119.1h-33c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h33c1.2,0,2.2,1,2.2,2.2 S119.2,119.1,117.9,119.1z"/> <path d="M74.9,122.8h-8.8c-1,0-1.8-0.8-1.8-1.8v-8.4c0-1,0.8-1.8,1.8-1.8h8.8c1,0,1.8,0.8,1.8,1.8v8.4 C76.7,122.1,75.9,122.8,74.9,122.8z M67.8,119.3h5.3v-4.9h-5.3V119.3z"/> </g> </svg>',
        },
        {
            type: 'doc',
            icon: '<svg version="1.1" class="resource-icon" id="resourceType_doc" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve"> <path id="resourceBackground" d="M146,52.3c-0.2-1.7-1-3.3-2.2-4.5l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2l0,0H47.8 c-4.5,0-8.2,3.7-8.2,8.2v124.6c0,4.5,3.7,8.2,8.2,8.2h90.1c4.5,0,8.2-3.7,8.2-8.2V53.2l0,0L146,52.3L146,52.3L146,52.3z"/> <g style="opacity:0.1;"> <path d="M146.1,53.2L146.1,53.2c0-2-0.8-4-2.2-5.4l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2v24.1c0,3.6,2.9,6.5,6.5,6.5 L146.1,53.2L146.1,53.2z"/> </g> <g id="resourceObject"> <path d="M116.5,84.1h-49c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h49c1.2,0,2.2,1,2.2,2.2 S117.7,84.1,116.5,84.1z"/> <path d="M116.5,96.5h-49c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h49c1.2,0,2.2,1,2.2,2.2 S117.7,96.5,116.5,96.5z"/> <path d="M116.5,108.9h-49c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h49c1.2,0,2.2,1,2.2,2.2 S117.7,108.9,116.5,108.9z"/> <path d="M116.5,121.4H89.9c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h26.6c1.2,0,2.2,1,2.2,2.2 S117.7,121.4,116.5,121.4z"/> <path d="M77.9,121.4H67.5c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h10.4c1.2,0,2.2,1,2.2,2.2 S79.2,121.4,77.9,121.4z"/> </g> </svg>',
        },
        {
            type: 'graph',
            icon: '<svg version="1.1" class="resource-icon" id="resourceType_graph" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve"> <path id="resourceBackground" d="M146,52.3c-0.2-1.7-1-3.3-2.2-4.5l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2l0,0H47.8 c-4.5,0-8.2,3.7-8.2,8.2v124.6c0,4.5,3.7,8.2,8.2,8.2h90.1c4.5,0,8.2-3.7,8.2-8.2V53.2l0,0L146,52.3L146,52.3L146,52.3z"/> <g style="opacity:0.1;"> <path d="M146.1,53.2L146.1,53.2c0-2-0.8-4-2.2-5.4l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2v24.1c0,3.6,2.9,6.5,6.5,6.5 L146.1,53.2L146.1,53.2z"/> </g> <g id="resourceObject"> <path d="M87.4,124.7c-11.9,0-21.6-9.7-21.6-21.6s9-21,20.6-21.6c0.6,0,1.2,0.2,1.6,0.6 c0.4,0.4,0.7,1,0.7,1.5v18.3h18.3c0.6,0,1.1,0.2,1.5,0.7c0.4,0.4,0.6,1,0.6,1.6C108.4,115.6,99,124.7,87.4,124.7L87.4,124.7z M84.3,86C76.2,87.4,70,94.5,70,103.1c0,9.6,7.8,17.4,17.4,17.4c8.5,0,15.7-6.1,17.1-14.3h-18c-1.2,0-2.1-0.9-2.1-2.1V86z"/> <path d="M116.1,96H95.7c-1.2,0-2.1-0.9-2.1-2.1V73.5c0-1.1,0.9-2.1,2-2.1c0.3,0,0.7,0,1,0 c11.9,0,21.6,9.7,21.6,21.6c0,0.3,0,0.7,0,1C118.1,95.1,117.2,96,116.1,96z M97.8,91.7h16.1c-0.6-8.6-7.5-15.6-16.1-16.1V91.7z" /> </g> </svg> ',
        },
        {
            type: 'image',
            icon: '<svg version="1.1" class="resource-icon" id="resourceType_image" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve"> <path id="resourceBackground" d="M146,52.3c-0.2-1.7-1-3.3-2.2-4.5l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2l0,0H47.8 c-4.5,0-8.2,3.7-8.2,8.2v124.6c0,4.5,3.7,8.2,8.2,8.2h90.1c4.5,0,8.2-3.7,8.2-8.2V53.2l0,0L146,52.3L146,52.3L146,52.3z"/> <g style="opacity:0.1;"> <path d="M146.1,53.2L146.1,53.2c0-2-0.8-4-2.2-5.4l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2v24.1c0,3.6,2.9,6.5,6.5,6.5 L146.1,53.2L146.1,53.2z"/> </g> <g id="resourceObject"> <path d="M116.5,121.4h-49c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h49c1.2,0,2.2,1,2.2,2.2 S117.7,121.4,116.5,121.4z"/> <path d="M116.5,109h-49c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h49c1.2,0,2.2,1,2.2,2.2S117.7,109,116.5,109z "/> <path d="M116.5,84.1H93.1c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h23.4c1.2,0,2.2,1,2.2,2.2 S117.7,84.1,116.5,84.1z"/> <path d="M116.5,96.5H93.1c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h23.4c1.2,0,2.2,1,2.2,2.2 S117.7,96.5,116.5,96.5z"/> <path d="M81.6,96H67.5c-1,0-1.8-0.8-1.8-1.8V80.9c0-1,0.8-1.8,1.8-1.8h14.1c1,0,1.8,0.8,1.8,1.8v13.4 C83.4,95.3,82.6,96,81.6,96z M69.2,92.5h10.6v-9.9H69.2V92.5z"/> </g> </svg>',
        },
        {
            type: 'presentation',
            icon: '<svg version="1.1" class="resource-icon" id="resourceType_presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve"> <path id="resourceBackground" d="M146,52.3c-0.2-1.7-1-3.3-2.2-4.5l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2l0,0H47.8 c-4.5,0-8.2,3.7-8.2,8.2v124.6c0,4.5,3.7,8.2,8.2,8.2h90.1c4.5,0,8.2-3.7,8.2-8.2V53.2l0,0L146,52.3L146,52.3L146,52.3z"/> <g style="opacity:0.1;"> <path d="M146.1,53.2L146.1,53.2c0-2-0.8-4-2.2-5.4l-22.9-22.9c-1.4-1.4-3.4-2.2-5.4-2.2v24.1c0,3.6,2.9,6.5,6.5,6.5 L146.1,53.2L146.1,53.2z"/></g> <g id="resourceObject"> <path d="M104.3,110.5H68.6c-1.2,0-2.2-1-2.2-2.2V81.8c0-1.2,1-2.2,2.2-2.2h35.7c1.2,0,2.2,1,2.2,2.2v26.4 C106.6,109.5,105.6,110.5,104.3,110.5z M70.9,106h31.2V84.1H70.9V106z"/> <path d="M115.4,121.3H79.7c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h33.4V92.7c0-1.2,1-2.2,2.2-2.2 s2.2,1,2.2,2.2v26.4C117.6,120.3,116.6,121.3,115.4,121.3z"/> </g> </g> </svg>',
        },
    ];

    const pillarIcons = [
        {
            name: 'electricity',
            icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 59 104" style="enable-background:new 0 0 59 104;" xml:space="preserve"> <path style="fill:#FFFFFF;" d="M58.97,43.32c-0.42-0.82-1.25-1.33-2.17-1.33H37.85l5.32-38.78C43.32,2.08,42.68,1,41.61,0.6 c-0.28-0.11-0.57-0.16-0.87-0.16c-0.82,0-1.58,0.41-2.03,1.1L0.56,59.31c-0.5,0.75-0.54,1.71-0.11,2.5C0.88,62.61,1.7,63.1,2.6,63.1 h18.75l-7.88,37.87c-0.23,1.12,0.36,2.27,1.41,2.73c0.31,0.13,0.63,0.2,0.96,0.2c0.78,0,1.55-0.36,2.01-1.01l40.94-57.03 C59.32,45.11,59.39,44.14,58.97,43.32z M26.74,61.16c0.15-0.72-0.03-1.47-0.5-2.04c-0.47-0.57-1.16-0.9-1.9-0.9H7.14l27.98-42.38 l1.31,0.49l-3.81,27.77c-0.1,0.7,0.12,1.41,0.58,1.94c0.46,0.53,1.13,0.84,1.84,0.84h16.99L22.58,87.92l-1.29-0.56L26.74,61.16z"/> </svg> ',
        },
        {
            name: 'environment',
            icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 67 96" style="enable-background:new 0 0 67 96;" xml:space="preserve"> <path style="fill:#FFFFFF;" d="M65.56,48.31c-1.2-6.51-3.62-12.65-7.18-18.22C51.6,18.91,43.3,8.73,33.73-0.15l-0.34-0.31 l-0.59,0.54C27.5,5.06,22.52,10.49,18.01,16.2C12.2,23.19,7.43,30.96,3.83,39.28c-2.9,6.33-3.81,13.29-2.62,20.13 c2.1,12.48,11.36,22.6,23.58,25.79c1.28,0.39,2.56,0.62,3.93,0.86c0.62,0.11,1.25,0.22,1.88,0.35l0.31,0.06v9.58h4.95v-9.7 l0.32-0.06c0.1-0.02,0.19-0.04,0.27-0.05c0.13-0.03,0.25-0.06,0.43-0.06c5.74-0.5,11.21-2.63,15.81-6.16 C62.75,72.88,67.81,60.43,65.56,48.31z M8.85,39.54l7.17-12.72l0.35,0.3c0.42,0.36,0.62,0.56,0.8,0.74 c4.36,4.34,8.75,8.74,13.04,13.08c0.38,0.38,0.62,0.88,0.67,1.39c0.03,6,0.03,12.03,0.03,17.86c0,0.11-0.01,0.22-0.02,0.32 l-0.02,1.04L8.85,39.54z M30.16,68.15c0.45,0.49,0.7,1.09,0.73,1.71c0.04,2.55,0.04,5.07,0.03,7.52l0,3.85l-0.42-0.04 c-1.8-0.18-3.59-0.54-5.32-1.07c-7.03-2.16-12.8-6.92-16.25-13.42c-3.45-6.5-4.16-13.94-2-20.97l0.18-0.58l0.65,0.58 c0.18,0.16,0.36,0.32,0.53,0.49C15.55,53.49,22.92,60.86,30.16,68.15z M19.14,22.54L30.16,9.48l0.7,0.47l-0.02,24.32L19.14,22.54z M35.89,34.25V8.97l0.66,0.7c3.8,4.01,7.42,8.28,10.74,12.7l0.2,0.27L35.89,34.25z M35.87,42.56c-0.03-0.42,0.11-0.92,0.36-1.28 l0.06-0.08c3.94-3.98,7.84-7.89,11.98-12.03l2.43-2.43l7.21,12.81L35.87,61.6l0-7.45c0-3.85-0.01-7.69,0-11.56L35.87,42.56z M35.81,71.77L35.81,71.77c-0.15-1.89,0.63-3.76,2.11-5.01c5.52-5.41,11.13-11.05,16.6-16.54l3.92-3.94 c0.19-0.24,0.4-0.56,0.57-0.87l0.43-0.78l0.27,0.85c0.57,1.79,0.96,3.66,1.15,5.54c0.75,7.32-1.39,14.49-6.03,20.2 S43.6,80.47,36.28,81.23l-0.42,0.04v-0.43c0-0.92,0.01-1.84,0.02-2.82C35.91,75.87,35.93,73.84,35.81,71.77z"/> </svg>',
        },
        {
            name: 'safety',
            icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 76 90" style="enable-background:new 0 0 76 90;" xml:space="preserve"> <g> <path style="fill:#FFFFFF;" d="M38.5,89.01c7.87-1.46,15.2-5.02,21.2-10.29c10.38-8.86,16.22-21.74,16.02-35.34 c0.02-4.33,0.01-8.69,0-12.99l-0.01-15.61c0-2.07-0.45-2.69-2.4-3.3L46.51,3.09c-1.64-0.52-3.31-1.06-4.93-1.58l-2.86-0.93 l-1.26-0.06L2.45,11.51l-0.16,0.02c-0.7,0.09-1.32,0.45-1.76,1.01c-0.41,0.54-0.61,1.21-0.53,1.8l0.02,0.25v28.89 c-0.07,7.18,1.59,14.35,4.81,20.76c6.1,12.46,17.35,21.36,30.85,24.45l0.12,0.03c0.67,0.2,1.36,0.32,2.11,0.35 C38.06,89.07,38.28,89.05,38.5,89.01z M36.31,83.77C28.86,81.86,22.04,78,16.6,72.61C11.28,66.95,7.6,60,5.92,52.45 C5.31,49.78,5,47,5,44.19c-0.08-6.6-0.07-13.3-0.06-19.78v-8.53l17.93-5.61c2.91-0.92,5.89-1.84,8.87-2.77l0.72-0.22l5.28-1.71 l0.54,0.17c6.44,2,12.99,4.05,19.33,6.04l13.16,4.1l0.01,13.83c0,4.52,0.01,9.65-0.05,14.6C70.53,63.55,57.31,79.85,38.6,83.95 l-0.14,0.02c-0.21,0.03-0.42,0.04-0.62,0.04C37.34,84.02,36.83,83.94,36.31,83.77z"/> <path style="fill:#FFFFFF;" d="M49.28,31.65L35.38,46.66l-5.73-6.53c-0.52-0.59-1.24-0.95-2.03-1c-0.07,0-0.13-0.01-0.2-0.01 c-0.72,0-1.4,0.26-1.95,0.73c-1.22,1.07-1.34,2.94-0.27,4.17l10.06,11.46l18.36-19.83c1.11-1.2,1.04-3.07-0.16-4.17 c-0.58-0.54-1.32-0.82-2.12-0.79C50.55,30.73,49.82,31.06,49.28,31.65L49.28,31.65z"/> </g> </svg>',
        },
        {
            name: 'grid',
            icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 80 90" style="enable-background:new 0 0 80 90;" xml:space="preserve"> <path style="fill:#FFFFFF;" d="M79.01,35.4L79.01,35.4c-0.01-0.68-0.29-1.32-0.79-1.77L59.21,16.16h10.62v3.24 c0,1.34,1.09,2.44,2.44,2.44c1.34,0,2.44-1.09,2.44-2.44l-0.01-5.71c-0.01-0.87-0.49-1.68-1.25-2.1L54.18,0.94 c-0.36-0.2-0.77-0.3-1.18-0.3H26.87c-0.41,0-0.82,0.1-1.18,0.3L6.39,11.6c-0.76,0.42-1.24,1.22-1.25,2.08l-0.01,5.73 c0,1.34,1.09,2.44,2.44,2.44S10,20.75,10,19.41v-3.24h10.58L1.6,33.63c-0.49,0.45-0.78,1.09-0.78,1.76c0,0.01,0,0.17,0,5.71 c0,1.34,1.09,2.44,2.43,2.44c1.34,0,2.44-1.09,2.44-2.44v-3.24h17.9L9.14,88.43l1.37,0.36l0.04-0.14h4.03l0.4,0.31l24.93-32.47 l24.93,32.47l0.4-0.31h4.02l0.05,0.17l1.37-0.39L56.24,37.86h17.9v3.24c0,1.34,1.09,2.44,2.44,2.44c1.34,0,2.43-1.09,2.43-2.44 C79.01,35.48,79.01,35.4,79.01,35.4z M62.83,11.29H17.02L27.5,5.51h24.88L62.83,11.29z M70.33,32.99H55.42V19.29L70.33,32.99z M52,40.74l10.69,37.4l-19.7-25.66L52,40.74z M36.84,52.48l-19.7,25.66l10.69-37.4L36.84,52.48z M50.55,16.16v16.82H29.28V16.16 H50.55z M24.41,19.26v13.73H9.49L24.41,19.26z M48.07,37.86l-8.16,10.62l-8.16-10.62H48.07z"/> </svg>',
        },
        {
            name: 'partnership',
            icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 91.5 80" style="enable-background:new 0 0 91.5 80;" xml:space="preserve"> <path style="fill:#FFFFFF;" d="M91.1,25.82c-0.09-0.62-0.41-1.19-0.85-1.51l-0.12-0.1C82.59,16.69,75.05,9.18,67.59,1.76l-0.11-0.12 c-0.17-0.23-0.37-0.43-0.6-0.59C66.33,0.67,65.66,0.52,65,0.64c-0.63,0.11-1.21,0.47-1.52,0.91l-1.87,1.88 c-1.83,1.81-3.65,3.62-5.47,5.47c-0.76,0.8-1.83,1.26-2.93,1.26l-0.15,0c-4.84-0.03-9.83-0.03-15.31,0 c-1.16,0.09-2.28-0.37-3.18-1.32c-1.54-1.56-3.12-3.12-4.69-4.68l-2.25-2.25c-0.19-0.28-0.44-0.53-0.72-0.71 c-0.58-0.39-1.25-0.52-1.95-0.38c-0.65,0.13-1.24,0.51-1.53,0.97L1.81,23.4c-0.42,0.43-0.84,0.87-1.25,1.31L0,25.29l0,2.09 l0.22,0.25c0.23,0.27,0.45,0.53,0.7,0.77c1.98,1.97,3.96,3.93,5.98,5.93c1.37,1.24,2.18,2.95,2.29,4.79 c0.02,2.19,0.58,4.39,1.56,6.14l0.09,0.22c0.12,0.42,0.05,0.89-0.2,1.25c-0.21,0.3-0.41,0.64-0.6,1.02 c-1.88,3.81-0.3,8.46,3.56,10.36c0.89,0.38,1.89,0.72,2.88,0.99l0.51,0.13l0.11,0.62c0.03,0.22,0.07,0.46,0.12,0.71 c0.67,3.11,3.26,5.53,6.47,6.02c0.86,0.07,1.11,0.54,1.24,1.26c0.44,2.99,2.59,5.43,5.46,6.22c1.46,0.43,3.01,0.46,4.47,0.06 l0.66-0.18l0.46,0.94c0.07,0.14,0.13,0.26,0.2,0.39c1.01,1.85,2.68,3.19,4.69,3.77c0.71,0.21,1.45,0.32,2.19,0.32 c1.31,0,2.62-0.33,3.79-0.97c1.77-1.01,3.27-2.47,4.33-4.22l0.46-0.75l0.72,0.5c0.13,0.09,0.25,0.18,0.36,0.24 c1.09,0.75,2.34,1.2,3.61,1.28c4.24,0.45,7.98-2.5,8.52-6.67c0.09-0.6,0.3-1,1.02-1.1c3.55-0.42,6.33-3.16,6.75-6.67 c0.04-0.29,0.1-0.48,0.19-0.62L73.03,60h0.26l0.11-0.01c0.06-0.01,0.13-0.02,0.19-0.03c1.42-0.14,2.74-0.69,3.82-1.58 c3.26-2.51,3.98-7.14,1.62-10.56c-0.32-0.41-0.32-1,0.04-1.46c1.58-2.34,2.44-5.09,2.48-7.96c0.01-1.21,0.54-2.37,1.47-3.2 c1.87-1.82,3.75-3.71,5.63-5.6l1.5-1.5c0.18-0.13,0.34-0.3,0.48-0.48C91.02,27.09,91.19,26.46,91.1,25.82z M63.25,48.78 c-0.49,0.08-0.94,0.32-1.29,0.68c-0.9,0.92-0.88,2.4,0.02,3.28c0.72,0.76,1.43,1.46,2.14,2.16c0.91,0.89,1.77,1.74,2.59,2.63 c0.57,0.62,0.95,1.38,1.1,2.18c0.21,1.29-0.47,2.5-1.72,3.02c-1.15,0.58-2.57,0.32-3.47-0.64c-0.74-0.69-1.51-1.46-2.33-2.29 l-1.59-1.59c-0.36-0.37-0.72-0.73-1.07-1.05c-0.98-0.93-2.49-0.91-3.45,0.04c-0.89,0.9-0.88,2.35,0.01,3.23 c0.72,0.74,1.43,1.45,2.14,2.15l0.1,0.1c0.83,0.82,1.68,1.66,2.5,2.54c0.53,0.56,0.92,1.23,1.11,1.92c0.28,1.39-0.37,2.72-1.63,3.31 c-1.1,0.57-2.53,0.34-3.45-0.55c-1.44-1.37-2.87-2.82-4.06-4.03c-1.52-1.77-3.51-2.88-5.71-3.21l-0.09-0.02 c-0.21-0.05-0.43-0.18-0.57-0.33l-0.13-0.14L44.34,62c-1.22-4.13-1.34-4.3-4.35-6.28l-0.62-0.41l0.33-0.66 c1.46-2.87,0.96-6.36-1.23-8.67c-2.34-2.68-6.18-3.48-9.34-1.94l-0.71,0.34l-0.38-0.69c-0.44-0.8-0.99-1.51-1.66-2.11 c-3.05-2.78-7.7-2.83-10.81-0.1l-1.1,0.97l-0.25-1.45c-0.04-0.26-0.08-0.51-0.11-0.74l-0.5,0.06l0,0l0.49-0.16 c0.05-3.39-1.31-6.7-3.72-9.07c-0.55-0.53-1.09-1.07-1.64-1.62l-0.32-0.31c-0.63-0.63-1.27-1.27-1.99-1.96 c-0.08-0.06-0.16-0.12-0.24-0.18l-0.82-0.57L25.71,6.79l1.57,1.53c1.02,1,2.1,2.04,3.11,3.08l0.06,0.07 c1.29,1.58,3.01,2.68,4.98,3.18l1.27,0.32l-1.39,1.66c-0.71,0.86-1.4,1.69-2.09,2.5l-8.49,10.05c-0.28,0.22-0.5,0.51-0.65,0.82 c-0.29,0.6-0.33,1.28-0.12,1.91c0.21,0.59,0.61,1.06,1.11,1.3l0.18,0.1c5.35,4,12.87,3.34,17.54-1.59c0.77-1.06,2.01-1.69,3.28-1.69 l0.14,0c0.59,0.06,1.16,0.21,1.71,0.45c2.33,1,4.93,1.47,7.51,1.33c0.6,0,1.13,0.19,1.52,0.53l17.55,17.43 c1.07,0.88,1.43,2.4,0.88,3.67l0,0c-0.16,0.39-0.41,0.74-0.7,1.02c-0.6,0.58-1.37,0.88-2.16,0.84c-0.81-0.02-1.58-0.36-2.16-0.96 c-1.1-1.05-2.21-2.16-3.31-3.27l-1.41-1.41C65.02,48.95,64.12,48.62,63.25,48.78z M32.96,69.68c-1.26,0.1-2.44-0.57-3.07-1.74 c-0.61-0.95-0.48-2.28,0.31-3.17c1.42-1.55,2.92-3.05,4.45-4.45c0.56-0.46,1.23-0.69,1.9-0.69c0.82,0,1.64,0.34,2.23,1.02 c1.04,1.08,1.09,2.82,0.13,3.95c-1.52,1.61-2.91,3-4.24,4.23l-0.08,0.07c-0.43,0.32-0.92,0.57-1.4,0.73L32.96,69.68z M13.96,50.85 c0.26-0.64,0.59-1.25,0.94-1.75l0.08-0.1c1.2-1.34,2.51-2.59,3.66-3.69l0.23-0.22c1.15-1.2,3.03-1.2,4.29-0.02 c0.58,0.55,0.92,1.3,0.94,2.11c0.02,0.81-0.27,1.58-0.83,2.17c-1.21,1.3-2.56,2.64-4.12,4.11l-0.01,0.01 c-0.85,0.84-2.22,1.05-3.36,0.43c-1-0.48-1.72-1.49-1.88-2.62l-0.03-0.22L13.96,50.85z M21.8,58.46l0.01-0.13l0.05-0.12 c0.23-0.55,0.55-1.09,0.9-1.54l0.07-0.08c2.49-2.58,4.99-5.03,7.34-7.33l0.43-0.42c1.21-1.07,3.03-1,4.23,0.14 c0.58,0.57,0.9,1.33,0.91,2.13s-0.3,1.56-0.87,2.13c-2.71,2.78-5.5,5.51-7.9,7.87c-0.84,0.87-2.29,1.1-3.42,0.5 C22.4,61.05,21.68,59.76,21.8,58.46z M40.13,70.83l0.05-0.13c0.66-1.51,1.9-2.69,3.37-3.22l0.16-0.04c0.2-0.04,0.4-0.06,0.59-0.06 c0.29,0,0.58,0.04,0.85,0.12c0.77,0.23,1.41,0.74,1.79,1.45c0.38,0.7,0.48,1.52,0.26,2.26l-0.03,0.08c-0.67,1.7-2.13,2.94-3.92,3.33 l-0.17,0.02c-0.27,0-0.54-0.04-0.82-0.12c-0.8-0.23-1.45-0.75-1.85-1.46C40.04,72.35,39.93,71.53,40.13,70.83z M61.57,30.21 l0.84-0.57c0.66-0.44,1.3-0.95,1.93-1.52c1.32-1.41,2.53-2.88,3.6-4.39l0.09-0.14c0.3-0.53,0.38-1.12,0.22-1.71 c-0.15-0.57-0.53-1.06-1-1.33l-0.19-0.12c-0.55-0.31-1.18-0.38-1.79-0.22c-0.6,0.17-1.1,0.56-1.4,1.11 c-1.05,1.93-2.64,3.51-4.6,4.56c-2.67,1.43-5.81,1.63-8.59,0.56l-0.08-0.03c-1.85-0.9-3.94-1.26-6.07-1.04 c-1.65,0.28-3.24,1.12-4.49,2.39c-0.99,1.16-2.32,2.16-3.74,2.79c-1.67,0.64-3.51,0.77-5.19,0.36l-1.29-0.31l4.51-5.36 c2.61-3.09,5.21-6.19,7.76-9.23c0.72-0.75,1.66-1.11,2.75-1.05c1.9-0.07,3.83-0.08,5.72-0.08c0.83,0,1.65-0.01,2.5-0.02 c1.55,0.11,3.13-0.27,4.58-1.12c0.67-0.44,1.36-0.99,1.99-1.59c1.32-1.25,2.62-2.52,3.87-3.74l1.82-1.77l20.18,19.52l-1.95,1.9 c-1.3,1.27-2.54,2.48-3.8,3.67c-1.87,1.65-2.97,4.01-3.01,6.48c0,1.45-0.33,2.92-0.97,4.24l-0.5,1.03L61.57,30.21z"/> </svg>',
        },
        {
            name: 'outages',
            icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 93.5 83.5" style="enable-background:new 0 0 93.5 83.5;" xml:space="preserve"> <path style="fill:#FFFFFF;" d="M91.96,70.07c-10.79-18.78-21.79-37.7-32.42-56.01l-5.29-9.1c-0.41-0.7-0.92-1.34-1.51-1.9 c-1.56-1.47-3.68-2.32-5.89-2.33c-0.78,0-1.54,0.11-2.28,0.32c-2.09,0.59-3.93,2.01-5.03,3.89C26.81,26.8,14.12,48.71,1.83,70.07 c-0.52,0.9-0.86,1.88-1.02,2.9c-0.42,2.7,0.53,5.55,2.49,7.44c1.56,1.51,3.71,2.38,5.89,2.4c12.51,0.04,25.11,0.06,37.71,0.06 c12.6,0,25.2-0.02,37.72-0.06c0.9,0,1.79-0.15,2.63-0.43c2.18-0.72,4-2.32,5-4.4C93.44,75.5,93.33,72.46,91.96,70.07z M87.52,76.51 c-0.68,0.9-1.8,1.46-2.92,1.47c-21.81,0.07-44,0.04-65.46,0.01l-9.91-0.01l-0.17,0c-1.32-0.06-2.59-0.9-3.16-2.1 c-0.5-1.07-0.46-2.37,0.13-3.39c9.4-16.42,19.07-33.06,28.43-49.15l0.26-0.45c3-5.16,6-10.33,9-15.49c0.64-1.11,1.89-1.82,3.17-1.83 h0.03h0.01c1.26,0.01,2.5,0.72,3.14,1.81c9.95,16.98,20.18,34.73,29.21,50.39l8.48,14.7C88.49,73.72,88.39,75.35,87.52,76.51z"/> <path style="fill:#FFFFFF;" d="M59.33,44.08L59.33,44.08c-0.3-0.58-0.89-0.94-1.54-0.94h-7.52l2.22-16.2 c0.11-0.81-0.34-1.57-1.11-1.85c-0.75-0.28-1.62,0-2.05,0.67L32.65,51.01c-0.35,0.53-0.38,1.21-0.08,1.77 c0.3,0.56,0.89,0.91,1.52,0.91h7.38L38.2,69.45c-0.17,0.8,0.25,1.61,1,1.94c0.22,0.1,0.46,0.15,0.69,0.15 c0.55,0,1.08-0.26,1.41-0.72l17.9-24.93C59.58,45.35,59.63,44.66,59.33,44.08z M44.95,50.87c-0.33-0.41-0.82-0.64-1.34-0.64h-6.29 l10.71-16.22l-1.46,10.63c-0.07,0.5,0.08,1,0.41,1.37c0.33,0.38,0.8,0.59,1.3,0.59h6.14L43.25,62.15l2.05-9.84 C45.41,51.8,45.28,51.27,44.95,50.87z"/> </svg>',
        },
        {
            name: 'centre',
            icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 128 195.5" style="enable-background:new 0 0 128 195.5;" xml:space="preserve"> <g> <path style="fill:#FFFFFF;" d="M124.12,186.55c-20.86-2.54-40.25-12.45-54.61-27.9c3.07-3.87,5.88-8.03,8.36-12.36 c11.46,13.49,27.44,22.49,45.05,25.36c0.23,0.04,0.46,0.06,0.69,0.06c2.09,0,3.85-1.5,4.18-3.56c0.38-2.31-1.2-4.49-3.51-4.87 c-16.89-2.75-31.85-11.74-42.16-25.32c2.6-5.76,4.64-11.79,6.07-17.94c6.68,14.11,19.16,24.31,34.4,28.06l0,0 c0.34,0.08,0.68,0.12,1.02,0.12c1.96,0,3.65-1.33,4.12-3.23c0.56-2.27-0.84-4.58-3.11-5.13c-19.38-4.76-32.92-22.05-32.92-42.03 c0-19.98,13.54-37.26,32.92-42.03c2.27-0.56,3.67-2.86,3.11-5.13c-0.56-2.27-2.86-3.66-5.13-3.11 c-15.23,3.74-27.72,13.94-34.4,28.06c-1.43-6.15-3.47-12.19-6.07-17.94c10.31-13.58,25.28-22.57,42.16-25.32 c2.31-0.38,3.88-2.56,3.51-4.87c-0.18-1.12-0.79-2.1-1.72-2.77c-0.92-0.66-2.04-0.92-3.15-0.74c-17.61,2.87-33.6,11.87-45.05,25.36 c-2.48-4.33-5.29-8.48-8.36-12.36c14.36-15.46,33.74-25.37,54.61-27.91c1.13-0.14,2.13-0.7,2.83-1.6c0.7-0.89,1.01-2,0.87-3.13 c-0.14-1.13-0.71-2.14-1.6-2.84c-0.89-0.69-2-1-3.12-0.86c-22.52,2.74-43.53,13.35-59.18,29.89C48.26,13.95,27.26,3.34,4.74,0.6 C2.41,0.32,0.29,1.98,0.01,4.3c-0.14,1.13,0.17,2.24,0.87,3.13c0.7,0.89,1.7,1.46,2.83,1.6c20.86,2.54,40.25,12.45,54.61,27.91 c-3.07,3.87-5.88,8.03-8.36,12.36C38.5,35.8,22.52,26.8,4.91,23.93c-1.11-0.18-2.24,0.08-3.16,0.74c-0.92,0.66-1.53,1.64-1.71,2.76 c-0.38,2.31,1.2,4.49,3.51,4.87c16.89,2.75,31.85,11.74,42.16,25.32c-2.6,5.76-4.64,11.79-6.07,17.94 c-6.68-14.11-19.16-24.31-34.4-28.06c-2.27-0.55-4.58,0.84-5.13,3.11c-0.56,2.27,0.84,4.58,3.11,5.13 c19.38,4.76,32.92,22.05,32.92,42.03c0,19.98-13.54,37.26-32.92,42.03c-1.1,0.27-2.03,0.95-2.62,1.92 c-0.59,0.97-0.76,2.11-0.49,3.21c0.47,1.9,2.16,3.23,4.12,3.23c0.34,0,0.68-0.04,1.02-0.12c15.23-3.74,27.72-13.95,34.4-28.06 c1.43,6.16,3.47,12.19,6.07,17.95c-10.31,13.58-25.28,22.57-42.16,25.32c-2.31,0.38-3.88,2.56-3.51,4.87 c0.34,2.07,2.1,3.56,4.18,3.56c0.23,0,0.46-0.02,0.69-0.06c17.61-2.87,33.6-11.87,45.05-25.36c2.48,4.33,5.29,8.49,8.36,12.36 c-14.36,15.46-33.74,25.37-54.61,27.9c-1.13,0.14-2.13,0.7-2.83,1.6c-0.7,0.89-1.01,2-0.87,3.13c0.28,2.3,2.36,3.99,4.73,3.7 c22.53-2.74,43.53-13.35,59.18-29.89c15.65,16.54,36.65,27.15,59.18,29.89c0.17,0.02,0.35,0.03,0.52,0.03 c2.14,0,3.95-1.6,4.21-3.73c0.14-1.13-0.17-2.24-0.87-3.13C126.25,187.26,125.24,186.69,124.12,186.55z M68.63,97.79 c0-10.96,2.74-21.83,7.92-31.48c3.8,10.07,5.72,20.66,5.72,31.48c0,10.82-1.92,21.41-5.72,31.48 C71.36,119.61,68.63,108.74,68.63,97.79z M63.91,121.41c2.02,6.14,4.83,11.99,8.37,17.4c-2.39,4.62-5.2,9.06-8.37,13.2 c-3.16-4.15-5.98-8.59-8.37-13.2C59.08,133.39,61.89,127.55,63.91,121.41z M55.55,56.77c2.39-4.62,5.2-9.06,8.37-13.2 c3.16,4.14,5.98,8.58,8.37,13.2c-3.53,5.41-6.34,11.26-8.37,17.4C61.89,68.03,59.08,62.18,55.55,56.77z M59.2,97.79 c0,10.95-2.74,21.82-7.92,31.48c-3.8-10.07-5.72-20.66-5.72-31.48c0-10.82,1.92-21.41,5.72-31.48 C56.47,75.97,59.2,86.83,59.2,97.79z"/> </g> </svg>',
        },
    ];

    appDiv.innerHTML += `<div class="section-wrapper"><div class="animation-wrapper"><div class="icon-wrapper"></div><div class="pillar-wrapper"></div><div class="sonar-wrapper"></div></div></div>`;
    document.querySelector('.animation-wrapper').style.backgroundColor =
        miscColors[3].hex;
    const iconWrapper = document.querySelector('.icon-wrapper');
    const pillarWrapper = document.querySelector('.pillar-wrapper');
    const sonarWrapper = document.querySelector('.sonar-wrapper');

    // grid creation
    let iconGenerator = '';
    for (var i = 0; i <= 84; i++) {
        let randomType = Math.floor(Math.random() * (4 - 0 + 1)) + 0;
        // iconGenerator +=
        //     `<div class="icon"><div class="icon-shadow"></div>` +
        //     resourceTypes[randomType].icon +
        //     `</div>`;
        iconGenerator +=
            `<div class="icon">` +
            resourceTypes[randomType].icon +
            `</div>`;
    }
    iconWrapper.innerHTML += iconGenerator;

    // pillar creation
    for (var i = 0; i < 6; i++) {
        let initColor = 'default-color__' + pillarColors[i].color;
        pillarWrapper.innerHTML +=
            `<div class="pillar-icon categories ` +
            initColor +
            `">` +
            pillarIcons[i].icon +
            `</div>`;
    }

    // create final pillar
    let finalPillarColor = 'default-color__' + miscColors[0].color;
    pillarWrapper.innerHTML +=
        `<div class="pillar-icon final ` +
        finalPillarColor +
        `">` +
        pillarIcons[6].icon +
        `</div>`;

    // create sonar waves
    for (var i = 0; i < 4; i++) {
        sonarWrapper.innerHTML += `<div class="sonar-waves"></div>`;
    }

    function deleteIcons() {
        iconWrapper.remove();
    }

    // floating animation
    const randomX = random(1, 10);
    const randomY = random(1, 10);
    const randomDelay = random(0, 1);
    const randomTime = random(3, 5);
    const randomTime2 = random(5, 10);
    const randomAngle = random(-10, 10);

    let iconCounter = 0;
    const icons = gsap.utils.toArray('.icon');
    icons.forEach((icon) => {
        gsap.set(icon, {
            x: randomX(-1),
            y: randomX(1),
            rotation: randomAngle(-1),
        });

        let maxSize = 25;
        let minSize = 10;
        let maxPos = 100;
        let minPos = 0;
        let vertPosRange =
            Math.floor(Math.random() * (maxPos - minPos) + minPos) + '%';
        let horiPosRange =
            Math.floor(Math.random() * (maxPos - minPos) + minPos) + '%';
        let iconSize = Math.floor(Math.random() * (maxSize - minSize) + minSize);

        icon.style.top = vertPosRange;
        icon.style.left = horiPosRange;

        if (iconCounter <= 6) {
            let initColor = 'default-color__' + pillarColors[iconCounter].color;
            icon.classList.add(initColor, 'inital-icon');
        } else {
            let randomTypeColor = Math.floor(Math.random() * (6 - 0 + 1)) + 0;
            let randomColor = 'default-color__' + pillarColors[randomTypeColor].color;
            icon.classList.add(randomColor);
        }
        icon.style.width = iconSize + '%';
        icon.style.height = iconSize + '%';
        icon.style.marginLeft = '-' + iconSize / 2 + '%';
        icon.style.marginTop = '-' + iconSize / 2 + '%';

        moveX(icon, 1);
        moveY(icon, -1);
        rotate(icon, 1);
        iconCounter++;
    });
    const pillars = gsap.utils.toArray('.pillar-icon.categories');
    pillars.forEach((icon) => {
        gsap.set(icon, {
            x: randomX(-1),
            y: randomX(1),
        });
        moveX(icon, 1);
        moveY(icon, -1);
    });

    function rotate(target, direction) {
        gsap.to(target, randomTime2(), {
            rotation: randomAngle(direction),
            // delay: randomDelay(),
            ease: Sine.easeInOut,
            onComplete: rotate,
            onCompleteParams: [target, direction * -1],
        });
    }

    function moveX(target, direction) {
        gsap.to(target, randomTime(), {
            x: randomX(direction),
            ease: Sine.easeInOut,
            onComplete: moveX,
            onCompleteParams: [target, direction * -1],
        });
    }

    function moveY(target, direction) {
        gsap.to(target, randomTime(), {
            y: randomY(direction),
            ease: Sine.easeInOut,
            onComplete: moveY,
            onCompleteParams: [target, direction * -1],
        });
    }

    function random(min, max) {
        const delta = max - min;
        return (direction = 1) => (min + delta * Math.random()) * direction;
    }



    // ANIMATION DEFINITION
    // let pinAmount_process = window.innerHeight * 3.8;
    var processTL = gsap.timeline({
        repeat: -1
        // scrollTrigger: {
        //     trigger: ".section-process",
        //     start: "top top",
        //     end: () => `+=${pinAmount_process}`,
        //     scrub: 1,
        //     pin: '.section-process',
        // }
    });

    // STAGE 01
    processTL.from(
        '.icon',
        {
            scale: 0,
            stagger: {
                amount: 0.25,
                from: 'random',
            },
            duration: 1,
            ease: Elastic.easeOut,
        },
        '0.35'
    );

    // STAGE 02

    processTL.to(
        '.icon.default-color__yellow #resourceBackground',
        {
            fill: pillarColors[0].hex,
            stagger: {
                amount: 0.15,
                from: 'random',
            },
            duration: 0.15,
            ease: Power2.easeInOut,
        },
        '>2.5'
    );
    processTL.to(
        '.icon.default-color__green #resourceBackground',
        {
            fill: pillarColors[1].hex,
            stagger: {
                amount: 0.15,
                from: 'random',
            },
            duration: 0.15,
            ease: Power2.easeInOut,
        },
        '<'
    );
    processTL.to(
        '.icon.default-color__navy #resourceBackground',
        {
            fill: pillarColors[2].hex,
            stagger: {
                amount: 0.15,
                from: 'random',
            },
            duration: 0.15,
            ease: Power2.easeInOut,
        },
        '<'
    );
    processTL.to(
        '.icon.default-color__teal #resourceBackground',
        {
            fill: pillarColors[3].hex,
            stagger: {
                amount: 0.15,
                from: 'random',
            },
            duration: 0.15,
            ease: Power2.easeInOut,
        },
        '<'
    );
    processTL.to(
        '.icon.default-color__blue #resourceBackground',
        {
            fill: pillarColors[4].hex,
            stagger: {
                amount: 0.15,
                from: 'random',
            },
            duration: 0.15,
            ease: Power2.easeInOut,
        },
        '<'
    );
    processTL.to(
        '.icon.default-color__orange #resourceBackground',
        {
            fill: pillarColors[5].hex,
            stagger: {
                amount: 0.15,
                from: 'random',
            },
            duration: 0.15,
            ease: Power2.easeInOut,
        },
        '<'
    );

    processTL.to(
        '.icon #resourceObject path',
        {
            fill: miscColors[2].hex,
            duration: 0.25,
            ease: Power2.easeInOut,
        },
        '<+0.05'
    );

    // hide blank icons
    processTL.to(
        '.icon.default-color__white',
        {
            scale: 0,
            stagger: {
                amount: 0.25,
                from: 'random',
            },
            duration: 0.85,
            ease: Elastic.easeInOut,
        },
        '>+0.85'
    );
    processTL.to(
        '.icon.default-color__white',
        {
            opacity: 0,
            duration: 0.1,
            ease: Power2.easeInOut,
        },
        '>-0.1'
    );



    // STAGE 03

    processTL.to(
        '.icon.default-color__yellow',
        {
            scale: 0.45,
            top: '35%',
            left: '20%',
            stagger: {
                amount: 0.25,
                from: 'random',
            },
            duration: 0.25,
            ease: Sine.easeIn,
        },
        '>+2'
    );

    processTL.to(
        '.icon.default-color__green',
        {
            scale: 0.45,
            top: '35%',
            left: '50%',
            stagger: {
                amount: 0.25,
                from: 'random',
            },
            duration: 0.25,
            ease: Sine.easeIn,
        },
        '<'
    );

    processTL.to(
        '.icon.default-color__navy',
        {
            scale: 0.45,
            top: '35%',
            left: '80%',
            stagger: {
                amount: 0.25,
                from: 'random',
            },
            duration: 0.25,
            ease: Sine.easeIn,
        },
        '<'
    );

    processTL.to(
        '.icon.default-color__teal',
        {
            scale: 0.45,
            top: '65%',
            left: '20%',
            stagger: {
                amount: 0.25,
                from: 'random',
            },
            duration: 0.25,
            ease: Sine.easeIn,
        },
        '<'
    );

    processTL.to(
        '.icon.default-color__blue',
        {
            scale: 0.45,
            top: '65%',
            left: '50%',
            stagger: {
                amount: 0.25,
                from: 'random',
            },
            duration: 0.25,
            ease: Sine.easeIn,
        },
        '<'
    );

    processTL.to(
        '.icon.default-color__orange',
        {
            scale: 0.45,
            top: '65%',
            left: '80%',
            stagger: {
                amount: 0.25,
                from: 'random',
            },
            duration: 0.25,
            ease: Sine.easeIn,
        },
        '<'
    );

    processTL.to(
        '.pillar-icon.categories',
        {
            scale: 0.8,
            duration: 0.85,
            ease: Elastic.easeOut,
        },
        '>-0.25'
    );

    processTL.to(
        '.icon',
        {
            opacity: 0,
            duration: 0.25,
            ease: Power2.easeInOut,
        },
        '<'
    );



    // STAGE 04

    processTL.to(
        '.pillar-icon.categories',
        {
            left: '35%',
            top: '40%',
            duration: 0.35,
            ease: Sine.easeIn,
        },
        '>+3.75'
    );

    processTL.from(
        '.pillar-icon.final',
        {
            scale: 0,
            duration: 0.5,
            ease: Elastic.easeOut,
        },
        '>-0.15'
    );

    processTL.to(
        '.sonar-wrapper',
        {
            opacity: 1,
            duration: 0.1,
            ease: Power2.easeInOut,
        },
        '<'
    );

    processTL.to(
        '.pillar-icon.categories',
        {
            opacity: 0,
            duration: 0.1,
            ease: Power2.easeInOut,
        },
        '<'
    );

    // RETURN TO BEGINNING
    processTL.to(
        '.pillar-icon.final',
        {
            scale: 0,
            duration: 0.5,
            ease: Elastic.easeOut,
        },
        '>+3.9'
    );

    processTL.to(
        '.sonar-wrapper',
        {
            opacity: 0,
            duration: 0.25,
            ease: Power2.easeInOut,
        },
        '<'
    );

});